<template>
  <data-table :has-results="values.length > 0">
    <template slot="table-header">
      <tr>
        <th>ID</th>
        <th>Name</th>
        <th>Stats</th>
        <th class="text-right">Created At</th>
      </tr>
    </template>
    <template slot="table-body">
      <tr v-for="domain in values" :key="`campaign-stats-domains-tr-${domain.id}`">
        <td>{{ domain.id }}</td>
        <td>
          <router-link :to="{ name: 'domains-single', params: { id: domain.id } }">{{ domain.name }}</router-link>
        </td>
        <td>
          <stats-column :stats="domain.stats" :loaded="statsLoaded"/>
        </td>
        <td class="text-right">{{ domain.created_at }}</td>
      </tr>
    </template>
  </data-table>
</template>

<script>
import Base from '@/views/pages/campaigns/partials/stats/Base'

export default {
  name: 'CampaignStatsOffers',
  extends: Base
}
</script>
